<template>
    <div 
        class="wg-text"
        :class="{
            ['wg-color__' + realColor]: realColor,
            ['wg-bg-color__' + finalBackgroundColor]: finalBackgroundColor,
            [realFontWeight]: realFontWeight,
            'wg-text__clamp': lineClamp,
            'wg-flex__shrink': +realStyle.flexShrink === 0,
        }"
        :style="Object.assign(extraStyle, {
            fontSize: realFontSize,
            lineHeight: realLineHeight,
            margin: finalMargin,
            padding: finalPadding,
            borderRadius: finalBorderRadius ? finalBorderRadius : '',
            backgroundColor: customBackgroundColor,
            color: customColor,
            '-webkit-line-clamp': lineClamp
        })"
    ><!-- 去除元素之间的换行/制表符，以免影响whiteSpace
        --><slot name="prefix"></slot><!--
        --><span>{{renderText}}</span><span v-if="arrow" class="wg-arrow">{{arrow}}</span><!--
        --><slot name="suffix"></slot><!--
    --></div>
</template>
<script>
import Mixin from '../mixin.js';
import env from 'common/env';

export default {
    data () {
        return {
            customColor: '',
            defaultStyle: {
                fontSize: 17,
                lineHeight: 24,
                allowEmpty: false,
                color: '',
                arrow: '',
                fontWeight: '',
                lineClamp: 0,
                flexShrink: 1,
            }
        }
    },
    mixins: [Mixin],
    props: {
        text: {
            type: String|Number,
            default: ''
        },
        styleObject: {
            type: Object,
            default () {
                return {
                }
            }
        }
    },
    computed: {
        realStyle () {
            return Object.assign(this.defaultStyle, (this.styleObject || {}))
        },
        renderText () {
            let text = this.text + '';
            return text ? text : (this.realStyle.allowEmpty ? '\u00a0' : '')
        },
        realFontSize () {
            return this.realStyle.fontSize ? (this.realStyle.fontSize + 'px') : ''
        },
        realLineHeight () {
            let ratio = 1.4;
            if(this.realStyle.fontSize < 12) {
                ratio = 1.2
            }
            return (this.styleObject.lineHeight || Math.round(this.realStyle.fontSize * ratio)) + 'px'
        },
        realFontWeight () {
            let isIOS = env.isiOS;
            if(this.realStyle.fontWeight === 'medium') {
                return isIOS ? 'wg-font__medium': 'wg-font__bold'
            }else if(this.realStyle.fontWeight === 'bold') {
                return 'wg-font__bold'
            }
            return ''
        },
        realColor () {
            if(this.realStyle.color.indexOf('#') > -1 || this.realStyle.color.indexOf('rgb') > -1) {
                this.customColor = this.realStyle.color
                return ''
            }else {
                return this.realStyle.color
            }
        },
        lineClamp () {
            return this.realStyle.lineClamp
        },
        arrow () {
            return this.realStyle.arrow
        }
    }
}
</script>
<style lang="less">
</style>